/** Editor shortcuts wait while a dialog or the feedback composer is open, and
 * leave typing alone. A focused button or slider keeps only Space (its own
 * activation), so `I`/`O` still work after clicking the transport. */
export function shortcutBlocked(event:KeyboardEvent, active:boolean):boolean {
  const target = event.target;
  if (!active || event.metaKey || event.ctrlKey || event.altKey
    || document.querySelector('[role="alertdialog"], [data-coach-modal-active="true"]')) return true;
  if (!(target instanceof HTMLElement)) return false;
  if (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName) || target.isContentEditable) return true;
  return event.key === ' ' && (target.tagName === 'BUTTON' || ['slider', 'tab', 'menuitem'].includes(target.getAttribute('role') ?? ''));
}
